import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Layers } from '@helpers/layers';
import { Device, from } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import styled from 'styled-components';
const Container = styled.section `
  ${setCssVar('accentColor', brand.sage.sageDark)};
  ${setCssVar('bgColor', brand.grey.greyLight)};
  ${setCssVar('bgColorAlt', brand.white)};
  ${setCssVar('fgColor', brand.black)};


  display: flex;
  flex-wrap: wrap;
  margin: 22px 0;
  

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const Open = styled.button `
  display: inline-flex;
  align-items: center;
  background: none;
  border: 1px solid ${brand.sage.sageLight};
  color: ${brand.sage.sageLight};
  height: 48px;
  width: 100%;
  margin: 0 0 0 auto;
  padding: 0 25px 0 16px;
  border-radius: 5px 5px 0 0;

  > svg {
    display: block;
    height: 14px;
    margin-left: 16px;
    width: 14px;
    
  }

  > span {
    display: block;
    flex: 1 0 auto;
    ${fonts.matter.regular};
    font-size: 14px;
    line-height: 42px;
    text-align: left;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }
`;
const Overlay = styled.div `
  position: fixed;
  top: 0;
  right: 0;
  background: ${brand.white};
  height: 100%;
  transform: translateX(100vw);
  transition: transform 0.3s ease-out;
  width: 100%;
  z-index: ${Layers.Modal};

  @media (prefers-reduced-motion: reduce)  {
    transition: none;
  }

  .theme-rss & {
    background: ${cssVar('bgColor')};
  }

  [aria-active='true'] & {
    transform: translateX(0vw);
  }
`;
const Close = styled.button `
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  background: none;
  border: 0;
  color: ${brand.sage.sageDark};
  height: 48px;
  justify-content: center;
  margin: 0;
  padding: 0;
  width: 48px;

  > svg {
    display: block;
    height: 32px;
    width: 32px;
  }

  > span {
    ${srOnly};
  }
`;
const Background = styled.div `
  position: fixed;
  top: 0;
  right: 0;
  background: ${brand.black};
  height: 100%;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-out;
  width: 100%;
  z-index: ${Layers.Modal - 1};

  [aria-active='true'] & {
    opacity: 0.85;
    pointer-events: all;
  }
`;
const SelectedFilters = styled.div `
  flex: 1 0 100%;
`;
export default {
    Background,
    Close,
    Container,
    Open,
    Overlay,
    SelectedFilters,
};
